export default __webpack_public_path__ + "static/media/Website-Blur1.d377b5f8.png";